import { useTranslation } from 'react-i18next';

const BASE = 'scenes.kit.dashboard_alternative_mode.components.week_day_picker';

export type WeekDay = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const DEFAULT_WEEK_DAYS: WeekDay[] = [5, 6, 7];

const WEEK_DAYS: WeekDay[] = [1, 2, 3, 4, 5, 6, 7];

interface WeekDayPickerProps {
  value: WeekDay[];
  onChange: (days: WeekDay[]) => void;
  disabled?: boolean;
}

function WeekDayPicker({ value, onChange, disabled }: WeekDayPickerProps) {
  const { t } = useTranslation();

  const toggle = (day: WeekDay) => {
    if (value.includes(day)) {
      // No deseleccionar si es el único seleccionado
      if (value.length === 1) return;
      onChange(value.filter((d) => d !== day));
    } else {
      onChange([...value, day].sort((a, b) => a - b) as WeekDay[]);
    }
  };

  return (
    <div className="kit-dashboard-alt__weekday-picker">
      {WEEK_DAYS.map((day) => {
        const isSelected = value.includes(day);
        return (
          <button
            key={day}
            type="button"
            disabled={disabled}
            onClick={() => toggle(day)}
            className={[
              'kit-dashboard-alt__weekday-btn',
              isSelected ? 'kit-dashboard-alt__weekday-btn--active' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            title={t(`${BASE}.days.full.${day}`)}
          >
            {t(`${BASE}.days.short.${day}`)}
          </button>
        );
      })}
    </div>
  );
}

export default WeekDayPicker;
